import { EHomeSearchWidgetVariant } from '@/components/ui/HomeSearchWidget';

import { SectionWrapper } from '../../Section';
import { ETabsColorVariant, ETabsVariant, Tabs } from '../Tabs';
import { Headline } from './Headline';
import { HeroImage } from './HeroImage';
import { SearchWidget } from './SearchWidget';

type THeroLayoutProps = {
  headline: React.ReactNode | string;
  heroImage: string;
  subheadline: React.ReactNode | string;
  tabsColorVariant: ETabsColorVariant;
  tabsVariant: ETabsVariant;
  variant: EHomeSearchWidgetVariant;
};

export const HeroLayout = ({
  headline,
  heroImage,
  subheadline,
  tabsColorVariant,
  tabsVariant,
  variant,
}: THeroLayoutProps) => {
  return (
    <SectionWrapper className="relative flex flex-col w-full h-full my-auto">
      <div className="flex justify-between pt-3 pb-5 gap-10 lg:py-3">
        <div className="flex-shrink-0">
          <Tabs tabVariant={tabsVariant} colorVariant={tabsColorVariant} />
          <Headline headline={headline} subheadline={subheadline} />
        </div>
        <HeroImage heroImage={heroImage} className="flex-shrink -mr-10" />
      </div>
      <SearchWidget className="xxl:-mt-12" variant={variant} />
    </SectionWrapper>
  );
};
